import React, { memo } from 'react'

import Searchbar from '../../property-details/searchbar'

interface SearchAreaProps {
    searchRegionNode?: any
    showSearchbar?: boolean
    isAllInputModalOpen?: boolean
    onSearchIconClick?: React.MouseEventHandler<HTMLDivElement>
}

const SearchArea: React.FC<SearchAreaProps> = ({
    searchRegionNode,
    showSearchbar,
    isAllInputModalOpen,
    onSearchIconClick,
}) => {
    return (
        <>
            {showSearchbar && onSearchIconClick && (
                <Searchbar
                    searchRegionNode={searchRegionNode}
                    isAllInputModalOpen={!!isAllInputModalOpen}
                    onSearchIconClick={onSearchIconClick}
                />
            )}
        </>
    )
}

export default memo(SearchArea)
